<template>
    <div class="ele-body">
        <el-card shadow="never">
            <!-- 搜索表单 -->
            <el-form v-if="search_show" :model="table.where" label-width="auto" :inline="true"
                @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
                <el-row :gutter="15">

                    <el-form-item label="商品名称:">
                        <el-input v-model="table.where.name" placeholder="请输入商品名称" clearable />
                    </el-form-item>
                    <el-form-item label="上架状态:">
                        <el-select v-model="table.where.status" filterable placeholder="请选择">
                            <el-option label="上架" value="1"></el-option>
                            <el-option label=" 下架" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="创建时间:">
                        <el-date-picker v-model="table.where.create_time" type="datetimerange" start-placeholder="开始日期"
                            end-placeholder="结束日期" value-format="yyyy-MM-dd hh:mm:ss">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="原产地:">
                        <el-input v-model="table.where.address" placeholder="请输入原产地" clearable />
                    </el-form-item>
                    <el-form-item label="商品简介:">
                        <el-input v-model="table.where.brief" placeholder="请输入商品简介" clearable />
                    </el-form-item>
                    <el-form-item label="分类ID:">
                        <el-select v-model="table.where.goods_cat_id" filterable placeholder="请选择">

                            <el-option v-for="item in fresh_goods_cat_list" :key="item.id" :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="推荐:">
                        <el-select v-model="table.where.is_recommend" filterable placeholder="请选择">
                            <el-option label=" 推荐" value="1"></el-option>
                            <el-option label=" 正常" value="0"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="热门:">
                        <el-select v-model="table.where.is_hot" filterable placeholder="请选择">
                            <el-option label="热门" value="1"></el-option>
                            <el-option label="正常" value="0"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="新品:">
                        <el-select v-model="table.where.new_product" filterable placeholder="请选择">
                            <el-option label=" 新品 " value="1"></el-option>
                            <el-option label="正常" value="0"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="店铺ID:">
                        <el-select v-model="table.where.shop_id" filterable placeholder="请选择">

                            <el-option v-for="item in fresh_shop_management_list" :key="item.id" :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="库存:">
                        <el-input-number v-model="table.where.stock" placeholder="请输入库存" :controls="false"
                            controls-position="right" class="ele-fluid ele-text-left" clearable />
                    </el-form-item>
                    <el-form-item label="销售价:">
                        <el-input-number v-model="table.where.price" controls-position="right" :min="0"
                            :controls="false" :precision="2" class="ele-fluid ele-text-left" placeholder="请输入销售价"
                            clearable />
                    </el-form-item>

                    <el-form-item label="成本价:">
                        <el-input-number v-model="table.where.costprice" controls-position="right" :min="0"
                            :controls="false" :precision="2" class="ele-fluid ele-text-left" placeholder="请输入成本价"
                            clearable />
                    </el-form-item>
                    <el-form-item label="批发价:">
                        <el-input-number v-model="table.where.mktprice" controls-position="right" :min="0"
                            :controls="false" :precision="2" class="ele-fluid ele-text-left" placeholder="请输入批发价"
                            clearable />
                    </el-form-item>
                    <el-form-item label="数量:">
                        <el-input-number v-model="table.where.initial" placeholder="请输入数量" :controls="false"
                            controls-position="right" class="ele-fluid ele-text-left" clearable />
                    </el-form-item>
                    <el-form-item label="排序:">
                        <el-input-number v-model="table.where.sort" placeholder="请输入排序" :controls="false"
                            controls-position="right" class="ele-fluid ele-text-left" clearable />
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search"
                            class="ele-btn-icon">查询
                        </el-button>
                        <el-button @click="(table.where={})&&$refs.table.reload()">重置</el-button>
                        <el-button type="success" @click="exportExcel();" icon="el-icon-download" class="ele-btn-icon"
                            v-if="permission.includes('sys:freshgoods:export')">导出数据
                        </el-button>
                    </el-form-item>
                </el-row>
            </el-form>
            <!-- 操作按钮 -->

            <div class="ele-table-tool ele-table-tool-default">
                <el-button @click="(table.where={})&&$refs.table.reload()" type="info" icon="el-icon-refresh"
                    class="ele-btn-icon" size="small">刷新
                </el-button>
                <el-button @click="showEdit=true" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small"
                    v-if="permission.includes('sys:freshgoods:add')">添加
                </el-button>
                <el-button @click="remove()" type="danger" icon="el-icon-delete" class="ele-btn-icon" size="small"
                    v-if="permission.includes('sys:freshgoods:dall')">批量删除
                </el-button>
                <el-button :type="search_show?'warning':'info'" size="small" icon="el-icon-search"
                    @click="search_show=!search_show">搜索</el-button>
            </div>

            <!-- 数据表格 -->
            <ele-data-table ref="table" :config="table" :choose.sync="choose" height="calc(100vh - 315px)"
                highlight-current-row v-fit-columns>
                <template slot-scope="{index}">
                    <el-table-column type="selection" width="45" align="center" fixed="left" />
                    <el-table-column type="index" :index="index" label="编号" width="60" align="center" fixed="left"
                        show-overflow-tooltip />
                    <el-table-column prop="name" label="商品名称" sortable="custom" show-overflow-tooltip />

                    <el-table-column prop="thumbnail_pic" label="缩略图" show-overflow-tooltip>
                        <template slot-scope="{row}">
                            <el-image style="width: 50px; height: 50px" :src="row.thumbnail_pic"
                                :preview-src-list="[row.thumbnail_pic]">
                            </el-image>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="images" label="相册" show-overflow-tooltip >
                        <template slot-scope="{row}">
                            <el-image v-for="(item,index) in row.images" :key="index" style="width: 50px; height: 50px"
                                :src="item" :preview-src-list="row.images">
                            </el-image>
                        </template>
                    </el-table-column> -->
                    <el-table-column prop="status" label="上架状态" show-overflow-tooltip>
                        <template slot-scope="{row}">
                            <el-switch v-model="row.status" @change="editStatus(row,'status')" :active-value="1"
                                :inactive-value="0" />
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="address" label="原产地" sortable="custom" show-overflow-tooltip
                         />
                    <el-table-column prop="brief" label="商品简介" sortable="custom" show-overflow-tooltip
                         /> -->
                    <el-table-column prop="goods_cat_id" label="分类" show-overflow-tooltip>
                        <template slot-scope="{row}">
                            <el-tag v-for="(item,index) in row.goods_cat_id_info" :key="index">{{item.name}}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="is_recommend" label="推荐" show-overflow-tooltip>
                        <template slot-scope="{row}">
                            <el-switch v-model="row.is_recommend" @change="editStatus(row,'is_recommend')"
                                :active-value="1" :inactive-value="0" />
                        </template>
                    </el-table-column>
                    <el-table-column prop="status" label="热门" show-overflow-tooltip>
                        <template slot-scope="{row}">
                            <el-switch v-model="row.is_hot" @change="editStatus(row,'is_hot')" :active-value="1"
                                :inactive-value="0" />
                        </template>
                    </el-table-column>
                    <el-table-column prop="new_product" label="新品" show-overflow-tooltip>
                        <template slot-scope="{row}">
                            <el-switch v-model="row.new_product" @change="editStatus(row,'new_product')"
                                :active-value="1" :inactive-value="0" />
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="is_recommend" label="推荐" show-overflow-tooltip >
                        <template slot-scope="{row}">
                            <el-tag v-if="row.is_recommend == 1" :key="index"> 推荐</el-tag>
                            <el-tag v-if="row.is_recommend == 0" :key="index"> 正常</el-tag>
                        </template>
                    </el-table-column>

                    <el-table-column prop="is_hot" label="热门" show-overflow-tooltip >
                        <template slot-scope="{row}">
                            <el-tag v-if="row.is_hot == 10" :key="index"> 1=热门 0=正常</el-tag>
                        </template>
                    </el-table-column>

                    <el-table-column prop="new_product" label="新品" show-overflow-tooltip >
                        <template slot-scope="{row}">
                            <el-tag v-if="row.new_product == 1" :key="index"> 新品 </el-tag>
                            <el-tag v-if="row.new_product == 0" :key="index">正常</el-tag>
                        </template>
                    </el-table-column> -->
                    <el-table-column prop="shop_id" label="店铺" show-overflow-tooltip width="auto">
                        <template slot-scope="{row}">
                            <el-tag v-for="(item,index) in row.shop_id_info" :key="index">{{item.name}}</el-tag>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="initial" label="起订数量" sortable="custom" show-overflow-tooltip
                         /> -->
                    <el-table-column prop="stock" label="库存" sortable="custom" show-overflow-tooltip />
                    <el-table-column prop="price" label="销售价" sortable="custom" show-overflow-tooltip />
                    <!-- <el-table-column prop="costprice" label="成本价" sortable="custom" show-overflow-tooltip
                         />
                    <el-table-column prop="mktprice" label="批发价" sortable="custom" show-overflow-tooltip
                         /> -->
                    <el-table-column prop="sort" label="排序" sortable="custom" show-overflow-tooltip />
                    <el-table-column label="创建时间" sortable="custom" show-overflow-tooltip>
                        <template slot-scope="{row}">{{ row.create_time*1000 | toDateString }}</template>
                    </el-table-column>
                    <el-table-column label="更新时间" sortable="custom" show-overflow-tooltip>
                        <template slot-scope="{row}">{{ row.update_time*1000 | toDateString }}</template>
                    </el-table-column>
                    <el-table-column label="操作" width="130px" align="center" :resizable="false" fixed="right">
                        <template slot-scope="{row}">
                            <el-link @click="edit(row)" icon="el-icon-edit" type="primary" :underline="false"
                                v-if="permission.includes('sys:freshgoods:edit')">修改</el-link>
                            <el-popconfirm title="确定要删除此商品管理吗？" @confirm="remove(row)" class="ele-action">
                                <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false"
                                    v-if="permission.includes('sys:freshgoods:delete')">删除</el-link>
                            </el-popconfirm>
                        </template>
                    </el-table-column>
                </template>
            </ele-data-table>
        </el-card>
        <!-- 编辑弹窗 -->
        <el-dialog :title="editForm.id?'修改商品管理':'添加商品管理'" :visible.sync="showEdit" width="1200px"
            :destroy-on-close="true" :lock-scroll="false" @close="closeDialog" :close-on-click-modal="false">
            <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="auto" class="demo-ruleForm">
                <el-form-item label="商品名称:" prop="name">
                    <el-input v-model="editForm.name" placeholder="请输入商品名称" clearable />
                </el-form-item>
                <el-form-item label="缩略图:" prop="thumbnail_pic">
                    <ele-uploadimage :limit="1" v-model="editForm.thumbnail_pic"></ele-uploadimage>
                </el-form-item>
                <el-form-item label="相册:" prop="images">
                    <ele-uploadimage :limit="9" v-model="editForm.images"></ele-uploadimage>
                </el-form-item>
                <el-form-item label="商品简介:" prop="brief">
                    <el-input v-model="editForm.brief" placeholder="请输入商品简介" clearable />
                </el-form-item>
                <el-form-item label="单位:" prop="unit">
                    <el-input v-model="editForm.unit" placeholder="请输入单位" clearable />
                </el-form-item>
                <el-form-item label="详情:" prop="info">
                    <tinymce-editor v-model="editForm.info" :init="initEditor" />
                </el-form-item>
                <el-form-item label="一级分类:">
                    <el-select v-model="goods_cat_id" filterable placeholder="请选择" @change="selectGoodsCatId">
                        <el-option v-for="item in fresh_goods_cat_list_first" :key="item.id" :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="二级分类:" prop="goods_cat_id">
                    <el-select v-model="editForm.goods_cat_id" filterable placeholder="请选择">
                        <el-option v-for="item in fresh_goods_cat_list" :key="item.id" :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="店铺:" prop="shop_id">
                    <el-select v-model="editForm.shop_id" filterable placeholder="请选择">
                        <el-option v-for="item in fresh_shop_management_list" :key="item.id" :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="库存:" prop="stock">
                    <el-input-number v-model="editForm.stock" controls-position="right" :controls="false" :precision="0"
                        class="ele-fluid ele-text-left" placeholder="请输入库存" clearable />
                </el-form-item>
                <el-form-item label="起订数量:" prop="initial">
                    <el-input-number v-model="editForm.initial" controls-position="right" :controls="false"
                        :precision="0" class="ele-fluid ele-text-left" placeholder="请输入起订数量" clearable />
                </el-form-item>
                <el-form-item label="销售价:" prop="price">
                    <el-input-number v-model="editForm.price" controls-position="right" :min="0" :controls="false"
                        :precision="2" class="ele-fluid ele-text-left" placeholder="请输入销售价" clearable />
                </el-form-item>

                <el-form-item label="成本价:" prop="costprice">
                    <el-input-number v-model="editForm.costprice" controls-position="right" :min="0" :controls="false"
                        :precision="2" class="ele-fluid ele-text-left" placeholder="请输入成本价" clearable />
                </el-form-item>

                <el-form-item label="批发价:" prop="mktprice">
                    <el-input-number v-model="editForm.mktprice" controls-position="right" :min="0" :controls="false"
                        :precision="2" class="ele-fluid ele-text-left" placeholder="请输入批发价" clearable />
                </el-form-item>
                <!-- 规格-->
                <el-form-item label="规格属性:" prop="mktprice">
                    <el-select v-model="editForm.format_id" filterable placeholder="请选择规格" @change="changeFormat">
                        <el-option label="" value=""></el-option>
                        <el-option v-for="(item,index) in formatInfo" :key="index" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商品规格：" v-if="formatClass">
                    <div class="ikz-sku" v-for="(item,index) in formatClass" :key="index">
                        <el-col :span="2">
                            {{item.name}}：
                        </el-col>
                        <el-col :span="12">
                            <el-checkbox-group class="ikz-checkbox-box" v-model="checked_sku_info">
                                <div class="ikz-checkbox-box-item" v-for="(it,ix) in item.children" :key="ix">
                                    <el-checkbox :label="it.title"
                                        @change="checked=>handleCheckedCitiesChange(checked,index,it)">{{it.title}}
                                    </el-checkbox>
                                </div>
                            </el-checkbox-group>
                        </el-col>
                    </div>
                </el-form-item>
                <el-form-item label="">
                    <el-table ref="multipleTable" :data="tableColumnList.tableBodyList" stripe tooltip-effect="dark"
                        style="width: 100%;margin-top:1%;" border>
                        <el-table-column :label="item.propName" :property="item.prop"
                            v-for="item in tableColumnList.tableHeaderList" :key="item.prop" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row[scope.column.property] }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="sku_price" label="销售价格">
                            <template slot-scope="{row}">
                                <el-input type="number" v-model="row.sku_price" placeholder="输入价格"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="sku_costprice" label="成本价格">
                            <template slot-scope="{row}">
                                <el-input type="number" v-model="row.sku_costprice" placeholder="输入成本价格"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="sku_mktprice" label="批发价格">
                            <template slot-scope="{row}">
                                <el-input type="number" v-model="row.sku_mktprice" placeholder="输入批发价格"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="sku_stock" label="商品库存">
                            <template slot-scope="{row}">
                                <el-input type="number" v-model="row.sku_stock" placeholder="输入库存"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="sku_initial" label="起购数量">
                            <template slot-scope="{row}">
                                <el-input type="number" v-model="row.sku_initial" placeholder="起购数量"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="image" label="商品图片">
                            <template slot-scope="{row}">
                                <ele-uploadimage :limit="1" v-model="row.image"></ele-uploadimage>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>


                <el-form-item label="排序:" prop="sort">
                    <el-input-number v-model="editForm.sort" controls-position="right" :controls="false" :precision="0"
                        class="ele-fluid ele-text-left" placeholder="请输入排序" clearable />
                </el-form-item>

            </el-form>
            <div slot="footer">
                <el-button @click="closeDialog">取消</el-button>
                <el-button type="primary" @click="save">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {
        mapGetters
    } from "vuex";

    import EleUploadimage from '@/components/EleUploadimage'
    import TinymceEditor from '@/components/TinymceEditor'

    export default {
        name: "SysFreshGoods",
        components: {
            EleUploadimage,
            TinymceEditor,
        },
        data() {
            return {
                goods_cat_id: '',
                tableColumnList: {
                    // tableHeaderList: [],
                    // tableBodyList: []
                    // inventory: ''
                },
                privateGoodsItem: [
                    // {
                    //     privateSpecName: '', //规格名
                    //     dynamicTags: [], //规格值数组
                    //     inputVisible: false,
                    //     inputValue: ''
                    // },
                ],
                checked_sku_info: [],
                table: {
                    url: '/fresh/FreshGoods/index',
                    where: {
                        "thumbnail_pic": [],
                        "images": []
                    }
                }, // 表格配置
                choose: [], // 表格选中数据
                showEdit: false, // 是否显示表单弹窗
                editForm: {
                    "thumbnail_pic": [],
                    "images": []
                }, // 表单数据
                editFormTemp: {
                    "thumbnail_pic": [],
                    "images": []
                },
                admin_list: [],
                user_list: [],
                search_show: false,
                fresh_goods_cat_list: [],
                fresh_shop_management_list: [],
                fresh_goods_cat_list_first: [],
                formatInfo: {}, //全部规格数据
                format_index: '', //当前选中的规格index
                selectFormat: [], //选中规格信息
                tableData: [], //表格数据信息
                formatClass: [], //当前选中的规格数据class
                table_top: [], //表头数据
                editRules: { // 表单验证规则

                    name: [{
                        required: true,
                        message: '请输入商品名称',
                        trigger: 'blur'
                    }],


                    thumbnail_pic: [{
                        required: true,
                        message: '请上传缩略图',
                        trigger: 'blur'
                    }],


                    images: [{
                        required: true,
                        message: '请上传相册',
                        trigger: 'blur'
                    }],



                    create_time: [{
                        required: true,
                        message: '请选择创建时间',
                        trigger: 'blur'
                    }],

                    address: [{
                        required: true,
                        message: '请输入原产地',
                        trigger: 'blur'
                    }],


                    brief: [{
                        required: true,
                        message: '请输入商品简介',
                        trigger: 'blur'
                    }],


                    info: [{
                        required: true,
                        message: '请输入详情',
                        trigger: 'blur'
                    }],


                    goods_cat_id: [{
                        required: true,
                        message: '请选择分类ID',
                        trigger: 'blur'
                    }],


                    is_recommend: [{
                        required: true,
                        message: '请选择推荐',
                        trigger: 'blur'
                    }],


                    is_hot: [{
                        required: true,
                        message: '请选择热门',
                        trigger: 'blur'
                    }],


                    new_product: [{
                        required: true,
                        message: '请选择新品',
                        trigger: 'blur'
                    }],


                    shop_id: [{
                        required: true,
                        message: '请选择店铺ID',
                        trigger: 'blur'
                    }],


                    stock: [{
                        required: true,
                        message: '请输入库存',
                        trigger: 'blur'
                    }],


                    price: [{
                        required: true,
                        message: '请输入单价',
                        trigger: 'blur'
                    }],


                    costprice: [{
                        required: true,
                        message: '请输入成本价',
                        trigger: 'blur'
                    }],


                    mktprice: [{
                        required: true,
                        message: '请输入市场价',
                        trigger: 'blur'
                    }],


                    initial: [{
                        required: true,
                        message: '请输入起订数量',
                        trigger: 'blur'
                    }],
                },
            }
        },
        computed: {
            ...mapGetters(["permission"]),
            initEditor() {
                return {
                    height: 400,
                    file_picker_callback: this.file_picker_callback,
                    skin_url: this.$fresh.state.theme.theme === 'dark' ? '/tinymce/skins/ui/oxide-dark' :
                        '/tinymce/skins/ui/oxide',
                    content_css: this.$fresh.state.theme.theme === 'dark' ? '/tinymce/skins/content/dark/content.css' :
                        '/tinymce/skins/content/default/content.css',
                    images_upload_handler: (blobInfo, success, error) => {
                        let file = blobInfo.blob();
                        // 使用axios上传
                        const formData = new FormData();
                        formData.append('file', file, file.name);
                        this.$http.post('/upload/uploadImage', formData).then(res => {
                            if (res.data.code == 0) {
                                success(res.data.data);
                            } else {
                                error(res.data.msg);
                            }
                        }).catch(e => {
                            error(e.message);
                        });
                    }
                };
            },
            // 计算规格
            calculateAttribute() {
                // 初始化
                let obj = {}
                this.privateGoodsItem.forEach((item) => {
                    console.log(item);
                    // 判断有没有输入规格名
                    if (item.privateSpecName) {
                        //规格名:规格值     //'颜色':'尺寸'
                        obj[item.privateSpecName] = item.dynamicTags
                    }
                })

                return obj
            }
        },
        watch: {
            // 监听规格数据
            calculateAttribute(newVal) {
                if (this.tableColumnList.status) {
                    this.tableColumnList.status = false;
                } else {
                    let cloneNewVal = JSON.parse(JSON.stringify(newVal))
                    let attrName = [] //规格名数组
                    let attrValue = [] //规格值数组
                    for (let key in cloneNewVal) {
                        attrName.push(key)
                        attrValue.push(cloneNewVal[key])
                    }

                    // 表格内容数据（笛卡尔积算法）
                    let finalArr = this.cartesianProductOf(...attrValue)

                    let tableObj = {
                        tableBodyList: [],
                        tableHeaderList: []
                    }
                    // 表格内容
                    tableObj.tableBodyList = finalArr.map((item) => {
                        let obj = {
                            sku_price: '',
                            sku_costprice: '',
                            sku_mktprice: '',
                            sku_stock: '',
                            sku_initial: 1,
                            image: '',
                        }
                        for (let i = 0; i < item.length; i++) {
                            obj[attrName[i]] = item[i]
                        }
                        return obj
                    })

                    this.tableColumnList.tableBodyList = tableObj.tableBodyList //表格内容数据

                    // 表头
                    let skuTableArr = Object.keys(newVal)
                    tableObj.tableHeaderList = skuTableArr.map((item) => {
                        return {
                            prop: item,
                            propName: item
                        }
                    })
                    this.tableColumnList.tableHeaderList = tableObj.tableHeaderList // 表头
                }


            }
        },
        mounted() {
            // this.FreshGoodsCatAllList();
            this.FreshGoodsCatFirstAllList();

            this.FreshShopManagementAllList();
            this.formatAllInfo();
        },
        methods: {
            handleCheckedCitiesChange(e, index, item) {
                // 添加数据
                if (e) {
                    this.privateGoodsItem[index].dynamicTags.push(item.title);
                } else {
                    for (var i = 0; i < this.privateGoodsItem[index].dynamicTags.length; i++) {
                        if (this.privateGoodsItem[index].dynamicTags[i] == item.title) {
                            this.privateGoodsItem[index].dynamicTags.splice(i, 1);
                            break;
                        }
                    }
                }
            },

            /* 
             * 选择规格
             */
            changeFormat(e) {
                if (e === '') {
                    this.tableColumnList = {};
                    this.privateGoodsItem = [];
                    this.formatClass = [];
                    this.checked_sku_info = [];
                } else {
                    this.checked_sku_info = [];
                    this.tableColumnList = {};
                    this.privateGoodsItem = [];
                    for (var i = 0; i < this.formatInfo.length; i++) {
                        if (this.formatInfo[i].id == e) {
                            this.format_index = i;
                            this.formatClass = this.formatInfo[i].children;
                            for (var k = 0; k < this.formatInfo[i].children.length; k++) {
                                var temp_info = {
                                    privateSpecName: this.formatInfo[i].children[k].name, //规格名
                                    dynamicTags: [], //规格值数组
                                    inputVisible: false,
                                    inputValue: ''
                                }
                                this.privateGoodsItem.push(temp_info);
                            }
                            break;
                        }
                    }

                }
            },
            // 笛卡尔积算法
            cartesianProductOf(...args) {
                return args.reduce(
                    (total, current) => {
                        let ret = []
                        total.forEach((a) => {
                            current.forEach((b) => {
                                ret.push(a.concat([b]))
                            })
                        })
                        return ret
                    },
                    [
                        []
                    ]
                )
            },
            /**
             * 获取规格分类
             */
            formatAllInfo() {
                this.$http.get('/fresh/FreshGoodsFormat/allList').then(res => {
                    if (res.data.code === 0) {
                        this.formatInfo = res.data.data;
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },
            /**
             * 关闭
             */
            closeDialog() {
                this.showEdit = false;
                this.editForm = JSON.parse(JSON.stringify(this.editFormTemp));
            },
            /**
             * 显示编辑
             */
            edit(row) {
                this.$http.get('/fresh/FreshGoods/info?id=' + row.id).then(res => {
                    if (res.data.code === 0) {
                        this.showEdit = true;
                        setTimeout(() => {
                            this.editForm = res.data.data;
                            if (this.editForm.tableColumnList) {
                                this.editForm.tableColumnList.status = true;
                                this.tableColumnList = this.editForm.tableColumnList || [];
                                this.privateGoodsItem = this.editForm.privateGoodsItem || [];
                                this.checked_sku_info = this.editForm.checked_sku_info || [];
                                for (var i = 0; i < this.formatInfo.length; i++) {
                                    if (this.formatInfo[i].id == this.editForm.format_id) {
                                        this.format_index = i;
                                        this.formatClass = this.formatInfo[i].children;
                                        break;
                                    }
                                }
                            }
                            // console.log(this.privateGoodsItem);
                        }, 100);
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },
            /**
             * 保存编辑
             */
            save() {
                this.$refs['editForm'].validate((valid) => {
                    if (valid) {
                        if (this.privateGoodsItem.length > 0) {
                            this.editForm.tableColumnList = this.tableColumnList;
                            this.editForm.privateGoodsItem = this.privateGoodsItem;
                            this.editForm.checked_sku_info = this.checked_sku_info;
                        }
                        const loading = this.$loading({
                            lock: true
                        });
                        // tableColumnList: {
                        //     tableHeaderList: [],
                        //     tableBodyList: []
                        //     // inventory: ''
                        // },
                        // privateGoodsItem: [{
                        //     privateSpecName: '', //规格名
                        //     dynamicTags: [], //规格值数组
                        //     inputVisible: false,
                        //     inputValue: ''
                        // }],
                        this.$http.post('/fresh/FreshGoods/edit', this.editForm).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.showEdit = false;
                                this.$message({
                                    type: 'success',
                                    message: res.data.msg
                                });
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    } else {
                        return false;
                    }
                });
            },
            /**
             * 刪除(批量刪除)
             */
            remove(row) {
                console.log(row)
                if (!row) { // 批量删除
                    if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
                    let ids = this.choose.map(d => d.id);
                    this.$confirm('确定要删除选中的商品管理吗?', '提示', {
                        type: 'warning'
                    }).then(() => {
                        const loading = this.$loading({
                            lock: true
                        });
                        this.$http.post('/fresh/FreshGoods/delete', {
                            id: ids
                        }).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.$message({
                                    type: 'success',
                                    message: res.data.msg
                                });
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    }).catch(() => 0);
                } else { // 单个删除
                    const loading = this.$loading({
                        lock: true
                    });
                    this.$http.post('/fresh/FreshGoods/delete', {
                        id: row.id
                    }).then(res => {
                        loading.close();
                        if (res.data.code === 0) {
                            this.$message({
                                type: 'success',
                                message: res.data.msg
                            });
                            this.$refs.table.reload();
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        loading.close();
                        this.$message.error(e.message);
                    });
                }
            },

            /* 导出数据Excel */
            exportExcel() {
                let ids  = this.choose.map(d => d.id)
                if(ids.length == 0){
                    this.$message.error('请选择要导出的数据');
                    return false;
                }
                this.$http
                    .post("/user/UserMail/exportExcel", {id:ids})
                    .then((res) => {
                        let data = res.data;
                        if (data.code == 0) {
                            // 下载文件
                            window.location.href = data.data;
                            this.$message({
                                type: "success",
                                message: "导出成功",
                            });
                        } else {
                            this.$message.error("导出失败");
                        }
                    })
            },
            //查询其他信息
            FreshGoodsCatFirstAllList() {
                this.$http.post('/fresh/FreshGoodsCat/allList', {
                    parent_id: 0
                }).then(res => {
                    if (res.data.code === 0) {
                        this.fresh_goods_cat_list_first = res.data.data;
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },
            //查询其他信息
            FreshGoodsCatAllList(e) {
                this.$http.post('/fresh/FreshGoodsCat/allList', {
                    parent_id: e
                }).then(res => {
                    if (res.data.code === 0) {
                        this.fresh_goods_cat_list = res.data.data;
                        this.$set(this.editForm, 'goods_cat_id', '');
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },
            //选择
            selectGoodsCatId(e) {
                console.log(7987)
                console.log(e)
                this.FreshGoodsCatAllList(e);
            },
            //查询其他信息
            FreshShopManagementAllList() {
                this.$http.post('/fresh/FreshShopManagement/allList', {}).then(res => {
                    if (res.data.code === 0) {
                        this.fresh_shop_management_list = res.data.data;
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },

            /**
             * 更改状态
             */
            editStatus(row, name) {
                const loading = this.$loading({
                    lock: true
                });
                let data = {
                    id: row.id,
                    name: name,
                    value: row[name],
                }
                this.$http.post("/fresh/FreshGoods/status", data).then(res => {
                    loading.close();
                    if (res.data.code === 0) {
                        this.$message({
                            type: 'success',
                            message: res.data.msg
                        });
                    } else {
                        row[name] = !row[name] ? 1 : 0;
                        this.$message.error(res.data.msg);

                    }
                }).catch(e => {
                    loading.close();
                    this.$message.error(e.message);
                });
            },
        }
    }
</script>

<style scoped>
    .ele-block>>>.el-upload,
    .ele-block>>>.el-upload-dragger {
        width: 100%;
    }

    .ikz-sku {
        display: flex;
        align-items: center;
    }

    .ikz-checkbox-box-item {
        display: initial;
        margin-right: 10px;
    }
</style>
